// Shared vocabulary + labels for the fitter portal (mirrors backend enums).

export const FITTER_SERVICES = [
  { value: "carpet_fitting", label: "Carpet fitting", install: true },
  { value: "vinyl_fitting", label: "Vinyl fitting", install: true },
  { value: "laminate_fitting", label: "Laminate fitting", install: true },
  { value: "lvt_fitting", label: "LVT fitting", install: true },
  { value: "artificial_grass_fitting", label: "Artificial grass fitting", install: true },
  { value: "flooring_collection", label: "Flooring collection", install: false },
  { value: "measuring_service", label: "Measuring service", install: false },
  { value: "uplift_existing", label: "Uplift existing flooring", install: false },
  { value: "disposal", label: "Disposal", install: false },
  { value: "supply_underlay", label: "Supply underlay", install: false },
  { value: "supply_grippers", label: "Supply grippers", install: false },
  { value: "supply_door_bars", label: "Supply door bars", install: false },
  { value: "door_trimming", label: "Door trimming", install: false },
];

export const SERVICE_LABEL = Object.fromEntries(
  FITTER_SERVICES.map((s) => [s.value, s.label]),
);

// Services offered as choices today (artificial grass is paused; labels above stay for history).
export const FITTER_SERVICE_CHOICES = FITTER_SERVICES.filter((s) => s.value !== "artificial_grass_fitting");
export const INSTALL_SERVICES = FITTER_SERVICES.filter((s) => s.install).map((s) => s.value);

export const RADIUS_OPTIONS = [5, 10, 15, 20, 30, 50];

export const AVAILABILITY_OPTIONS = [
  { value: "weekdays", label: "Weekdays" },
  { value: "evenings", label: "Evenings" },
  { value: "saturdays", label: "Saturdays" },
  { value: "sundays", label: "Sundays" },
];

export const PARTNER_TYPES = [
  { value: "fitter", label: "Fitting only", hint: "I install flooring" },
  { value: "delivery", label: "Collection / delivery only", hint: "I collect and deliver, I don't fit" },
  { value: "both", label: "Fitting + collection", hint: "I do both" },
];

export const JOB_TYPE_LABEL = {
  collection: "Collection only",
  fitting: "Fitting only",
  collection_fitting: "Collection + fitting",
  delivery: "Delivery only",
  measuring: "Measuring service",
};

export const STATUS_OPTIONS = ["new", "contacted", "approved", "paused", "rejected"];

export const STATUS_STYLE = {
  new: "bg-blue-100 text-blue-800",
  contacted: "bg-amber-100 text-amber-800",
  approved: "bg-emerald-100 text-emerald-800",
  paused: "bg-slate-200 text-slate-700",
  rejected: "bg-red-100 text-red-800",
};
